import type { ExonnHubRangeFilterDefinition } from "src/admin/modules/b2b-gate-order/components/ExonnHub/ExonnHub.types.ts";
import { useState } from "react";

import { useExonnHubStore } from "src/admin/modules/b2b-gate-order/components/ExonnHub/useExonnHubStore.ts";
import { RangeInput } from "src/components/RangeInput/RangeInput.tsx";
import { HeadingV2 } from "src/components/HeadingV2/HeadingV2.tsx";
import * as styles from "./RangeFilter.style.ts";
import { isRangeFilterModel } from "src/admin/modules/b2b-gate-order/components/ExonnHub/ExonnHub.utils.ts";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";

export const RangeFilter = ({
  filter,
}: {
  filter: ExonnHubRangeFilterDefinition;
}) => {
  const { t } = useTranslation(TranslationNamespaceEnum.ExonnHubComponent);

  const store = useExonnHubStore();
  const [draftRangeValue, setDraftRangeValue] = useState([0, 0]);

  const [rangeInputEditMode, setRangeInputEditMode] = useState<
    string | undefined
  >(undefined);
  const filterModels = store.filterModels;

  const { min, max } = filter;

  const model = filterModels
    .filter(isRangeFilterModel)
    .find((model) => model.name === filter.name) || {
    name: filter.name,
    type: filter.type,
    value: [min, max],
  };

  const handleValueCommit = (value: number[]) => {
    const nextFilterModels = [
      ...filterModels.filter((f) => f.name !== filter.name),
      {
        ...model,
        query_param: filter.query_param,
        value: value as [number, number],
      },
    ];
    setDraftRangeValue(value);
    setRangeInputEditMode(undefined);
    store.setFilterModels(nextFilterModels);
  };

  const handleValueChange = (value: number[]) => {
    setDraftRangeValue(value);
    setRangeInputEditMode(filter.name);
  };

  const value =
    filter.name === rangeInputEditMode
      ? draftRangeValue
      : clampRange(model.value, [min, max]);

  return (
    <div key={filter.name} css={styles.rangeFilter}>
      <HeadingV2 h={6}>
        {t(`filter.${filter.name}.label`, {
          defaultValue: filter.label,
        })}
      </HeadingV2>
      `
      <RangeInput
        onValueChange={handleValueChange}
        onValueCommit={handleValueCommit}
        min={min}
        max={max}
        css={styles.rangeInput}
        value={value}
      />
    </div>
  );
};

const clampRange = (value: [number, number], boundaries: [number, number]) => {
  const [min, max] = boundaries;
  const [startValue, endValue] = value;
  const finalStartValue = startValue < min ? min : startValue;
  const finalEndValue = endValue > max ? max : endValue;
  return [finalStartValue, finalEndValue];
};
